import React from "react";
import { LoadingSpinner } from "./ui/loading-spinner";
import { useT } from "@/lib/i18n";

export function PageLoading() {
  const t = useT();
  return (
    <div className="flex items-center justify-center min-h-64 w-full">
      <div className="flex flex-col items-center gap-3">
        <LoadingSpinner />
        <p className="text-sm text-muted-foreground">{t("addin-loading")}</p>
      </div>
    </div>
  );
}
